import React from 'react';
import { Loader2, Zap } from 'lucide-react';

const perCredit = (n) => `$${Number(n).toFixed(3)} / credit`;

// Credit top-up packs, driven entirely by the /billing/plans `topups` list.
// variant 'grid' = compact 3-column cards (Billing, Settings); 'list' = stacked rows (Prospects modal).
const TopUpPacks = ({ topups = [], loading, error, onReload, onSelect, busyKey = null, disabled = false, variant = 'grid' }) => {
  if (error) {
    return (
      <div className="text-sm text-gray-600 flex items-center gap-3">
        <span>We couldn't load the credit packs.</span>
        <button type="button" onClick={onReload} className="px-3 py-1.5 rounded-lg bg-indigo-600 text-white text-xs font-semibold hover:bg-indigo-700">Try again</button>
      </div>
    );
  }
  if (loading) {
    return <div className="flex justify-center py-4"><Loader2 className="w-5 h-5 animate-spin text-indigo-600" /></div>;
  }
  const off = disabled || !!busyKey;

  if (variant === 'list') {
    return (
      <div className="flex flex-col gap-2.5">
        {topups.map(({ key, credits, price, per_credit, best }) => (
          <button
            key={key}
            type="button"
            onClick={() => onSelect(key)}
            disabled={off}
            className={`flex items-center justify-between px-4 py-3.5 rounded-xl text-left transition disabled:opacity-50 disabled:cursor-not-allowed ${
              best ? 'border-2 border-indigo-600 bg-indigo-50' : 'border border-gray-200 bg-white hover:bg-gray-50'
            }`}
          >
            <div>
              <div className="flex items-center gap-2">
                <span className="font-bold text-gray-900 text-[0.95rem]">{Number(credits).toLocaleString()} credits</span>
                {best && <span className="bg-indigo-600 text-white text-[0.65rem] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide">Most popular</span>}
              </div>
              {per_credit != null && <span className="text-xs text-gray-400">{perCredit(per_credit)}</span>}
            </div>
            <span className={`text-xl font-extrabold ${best ? 'text-indigo-600' : 'text-gray-900'}`}>${price}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-3">
      {topups.map(({ key, credits, price, best }) => (
        <button
          key={key}
          type="button"
          onClick={() => onSelect(key)}
          disabled={off}
          className={`relative flex flex-col items-center p-4 border-2 border-solid rounded-xl cursor-pointer transition disabled:opacity-50 disabled:cursor-not-allowed ${
            best ? 'border-indigo-500 bg-indigo-50' : 'border-[#e9e8f1] bg-white hover:border-indigo-400 hover:bg-indigo-50'
          }`}
        >
          {best && (
            <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-indigo-600 text-white text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap">
              Most popular
            </span>
          )}
          {busyKey === `topup-${key}` ? (
            <Loader2 className="w-4 h-4 animate-spin text-indigo-600 mb-1" />
          ) : (
            <Zap className="w-4 h-4 text-indigo-500 mb-1" />
          )}
          <span className="font-bold text-gray-900 text-sm">{Number(credits).toLocaleString()}</span>
          <span className="text-xs text-gray-500">credits</span>
          <span className="text-sm font-semibold text-indigo-600 mt-1">${price}</span>
        </button>
      ))}
    </div>
  );
};

export default TopUpPacks;
